"use strict";

var _slicedToArray = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _FrozenMap_map, _FrozenSet_set;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrozenSet = exports.FrozenMap = void 0;
/**
 * A {@link ReadonlyMap} that cannot be modified after instantiation.
 * The implementation uses an inner map hidden via a private field, and the
 * immutability guarantee relies on it being impossible to get a reference
 * to this map.
 */

var FrozenMap = /*#__PURE__*/function () {
  function FrozenMap(entries) {
    _classCallCheck(this, FrozenMap);

    _FrozenMap_map.set(this, void 0);

    __classPrivateFieldSet(this, _FrozenMap_map, new Map(entries), "f");

    Object.freeze(this);
  }

  _createClass(FrozenMap, [{
    key: "size",
    get: function get() {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").size;
    }
  }, {
    key: (_FrozenMap_map = new WeakMap(), Symbol.iterator),
    value: function value() {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f")[Symbol.iterator]();
    }
  }, {
    key: "entries",
    value: function entries() {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").entries();
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn, thisArg) {
      var _this = this;

      // We have to wrap the specified callback in order to prevent it from
      // receiving a reference to the inner map.
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").forEach(function (value, key, _map) {
        return callbackfn.call(thisArg, value, key, _this);
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").get(key);
    }
  }, {
    key: "has",
    value: function has(key) {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").has(key);
    }
  }, {
    key: "keys",
    value: function keys() {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").keys();
    }
  }, {
    key: "values",
    value: function values() {
      return __classPrivateFieldGet(this, _FrozenMap_map, "f").values();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "FrozenMap(".concat(this.size, ") {").concat(this.size > 0 ? " ".concat(_toConsumableArray(this.entries()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return "".concat(String(key), " => ").concat(String(value));
      }).join(', '), " ") : '', "}");
    }
  }]);

  return FrozenMap;
}();

exports.FrozenMap = FrozenMap;
/**
 * A {@link ReadonlySet} that cannot be modified after instantiation.
 * The implementation uses an inner set hidden via a private field, and the
 * immutability guarantee relies on it being impossible to get a reference
 * to this set.
 */

var FrozenSet = /*#__PURE__*/function () {
  function FrozenSet(values) {
    _classCallCheck(this, FrozenSet);

    _FrozenSet_set.set(this, void 0);

    __classPrivateFieldSet(this, _FrozenSet_set, new Set(values), "f");

    Object.freeze(this);
  }

  _createClass(FrozenSet, [{
    key: "size",
    get: function get() {
      return __classPrivateFieldGet(this, _FrozenSet_set, "f").size;
    }
  }, {
    key: (_FrozenSet_set = new WeakMap(), Symbol.iterator),
    value: function value() {
      return __classPrivateFieldGet(this, _FrozenSet_set, "f")[Symbol.iterator]();
    }
  }, {
    key: "entries",
    value: function entries() {
      return __classPrivateFieldGet(this, _FrozenSet_set, "f").entries();
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn, thisArg) {
      var _this2 = this;

      // We have to wrap the specified callback in order to prevent it from
      // receiving a reference to the inner set.
      return __classPrivateFieldGet(this, _FrozenSet_set, "f").forEach(function (value, value2, _set) {
        return callbackfn.call(thisArg, value, value2, _this2);
      });
    }
  }, {
    key: "has",
    value: function has(value) {
      return __classPrivateFieldGet(this, _FrozenSet_set, "f").has(value);
    }
  }, {
    key: "keys",
    value: function keys() {
      return __classPrivateFieldGet(this, _FrozenSet_set, "f").keys();
    }
  }, {
    key: "values",
    value: function values() {
      return __classPrivateFieldGet(this, _FrozenSet_set, "f").values();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "FrozenSet(".concat(this.size, ") {").concat(this.size > 0 ? " ".concat(_toConsumableArray(this.values()).map(function (member) {
        return String(member);
      }).join(', '), " ") : '', "}");
    }
  }]);

  return FrozenSet;
}();

exports.FrozenSet = FrozenSet;
Object.freeze(FrozenMap);
Object.freeze(FrozenMap.prototype);
Object.freeze(FrozenSet);
Object.freeze(FrozenSet.prototype);